import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BreadcrumbItem from './BreadcrumbItem';
const defaultItems = [{
  label: 'Furniture',
  link: '/shop'
}];
const Breadcrumb = t0 => {
  const $ = _c(30);
  const {
    color: t1,
    forPage,
    items: initialItems,
    layout: t2,
    loading: t3,
    noPadding: t4
  } = t0;
  const color = t1 === undefined ? "dark" : t1;
  const layout = t2 === undefined ? "" : t2;
  const loading = t3 === undefined ? false : t3;
  const noPadding = t4 === undefined ? false : t4;
  const items = initialItems ?? defaultItems;
  const pageBreadcrumbRef = useRef(null);
  let t5;
  if ($[0] !== forPage || $[1] !== items) {
    t5 = forPage === "CategoryDesktop" && items.length >= 2 ? items.slice(1, items.length - 1) : items;
    $[0] = forPage;
    $[1] = items;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const desktopItems = t5;
  let t6;
  if ($[3] !== forPage) {
    t6 = () => {
      if (forPage && ["PDPMobile", "CategoryMobile"].includes(forPage)) {
        const element = pageBreadcrumbRef.current;
        if (element) {
          if (element.scrollWidth > element.clientWidth) {
            element.style.direction = "rtl";
          } else {
            element.style.direction = "ltr";
          }
        }
      }
    };
    $[3] = forPage;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== forPage || $[6] !== items) {
    t7 = [forPage, items];
    $[5] = forPage;
    $[6] = items;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  useEffect(t6, t7);
  const t8 = !noPadding;
  const t9 = layout !== "float";
  const t10 = layout === "float";
  const t11 = color !== "light";
  const t12 = color === "light";
  let t13;
  if ($[8] !== noPadding || $[9] !== t10 || $[10] !== t11 || $[11] !== t12 || $[12] !== t8 || $[13] !== t9) {
    t13 = classNames("z-auto m-0 mt-0 pt-2 pl-5", {
      "min-h-[45px]": t8,
      "min-h-[auto]": noPadding,
      static: t9,
      "absolute top-2.5 left-0 max-[1023px]:relative max-[1023px]:top-0": t10,
      "bg-gray-light9 border-gray-light7 border-b border-t md:pl-[50px]": t11,
      "bg-transparent border-0 [&_a]:text-gray-light1 [&_li:last-child_span]:last:text-gray-light1 [&_a:hover]:text-white sm:pt-0 sm:pl-0 md:mt-2": t12
    });
    $[8] = noPadding;
    $[9] = t10;
    $[10] = t11;
    $[11] = t12;
    $[12] = t8;
    $[13] = t9;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== noPadding) {
    t14 = classNames("list-none text-xs", {
      "m-0 p-0 lg:m-0": noPadding
    });
    $[15] = noPadding;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== desktopItems || $[18] !== items || $[19] !== loading) {
    let t16;
    if ($[21] !== items || $[22] !== loading) {
      t16 = (item, index) => <BreadcrumbItem loading={loading} key={item.label} isLast={index === items.length - 1} index={index} {...item} />;
      $[21] = items;
      $[22] = loading;
      $[23] = t16;
    } else {
      t16 = $[23];
    }
    t15 = desktopItems.map(t16);
    $[17] = desktopItems;
    $[18] = items;
    $[19] = loading;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[24] !== t14 || $[25] !== t15) {
    t16 = <ol className={t14} itemScope={true} itemType="https://schema.org/BreadcrumbList">{t15}</ol>;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t13 || $[28] !== t16) {
    t17 = <div className={t13} ref={pageBreadcrumbRef}>{t16}</div>;
    $[27] = t13;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  return t17;
};
Breadcrumb.propTypes = {
  color: PropTypes.oneOf(['light', 'dark']),
  layout: PropTypes.string,
  loading: PropTypes.bool,
  forPage: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    link: PropTypes.string,
    label: PropTypes.string.isRequired
  })),
  noPadding: PropTypes.bool
};
export const BreadcrumbPlaceholder = props => {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.forPage) {
    t0 = props.forPage === "CategoryDesktop" ? [{
      label: "1"
    }] : [{
      label: "1"
    }, {
      label: "2"
    }, {
      label: "3"
    }];
    $[0] = props.forPage;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props || $[3] !== t0) {
    t1 = <Breadcrumb {...props} loading={true} layout={props.layout} items={t0} />;
    $[2] = props;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
BreadcrumbPlaceholder.propTypes = {
  forPage: PropTypes.string,
  layout: PropTypes.string
};
export default Breadcrumb;